import {
  Alert,
  Grid,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import {
  deleteProductGroupItemThunk,
  createProductGroupItemThunk,
  productGroupSelector,
  updateProductGroupThunk,
} from "store/reducers/product/productGroupsSlice";
import {
  getProductsThunk,
  productSelector,
} from "store/reducers/product/productSlice";
import { LoadingButton } from "@mui/lab";
import {
  clearCurrentItem,
  clearStatus,
  createProductGroupThunk,
} from "store/reducers/product/productGroupsSlice";

const validation = yup.object({
  name: yup.string("Enter name").required("Name required"),
});

const itemValidation = yup.object({
  qty: yup.number().required("Name required").min(1),
});

const ProductGroupingCreate = ({ group_id, fullGrid }) => {
  const { status, itemStatus, currentItem } = useSelector(
    (state) => state.productGroup
  );
  const _currentItem = useSelector((state) =>
    productGroupSelector.selectById(state, currentItem)
  );
  const group = useSelector((state)=>
    productGroupSelector.selectById(state, group_id)
  )
  useEffect(() => {
    console.log({ currentItem, _currentItem });
  }, [currentItem, _currentItem]);
  const getGroup = () => {
    const _group = group ?? _currentItem;
    console.log(_group);
    return _group;
  };
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: group?.name ?? "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      console.log(data);
      if (group) {
        dispatch(updateProductGroupThunk({ id: group.id, data }));
      } else {
        dispatch(createProductGroupThunk(data));
      }
    },
    validateOnChange: false,
  });

  const formikGroup = useFormik({
    initialValues: {
      product: null,
      product_group: group ?? null,
      qty: 1,
    },
    validationSchema: itemValidation,
    onSubmit: (data) => {
      console.log(data);
      dispatch(
        createProductGroupItemThunk({
          ...data,
          product: data.product.id,
          product_group: getGroup() ?? null,
        })
      );
    },
    validateOnChange: false,
  });

  useEffect(() => {
    dispatch(getProductsThunk({ category: "", subCategory: "" ,page_size:1000}));
    return () => {
      dispatch(clearCurrentItem());
    };
  }, []);
  const products = useSelector(productSelector.selectAll);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const removeGroup = (id) => {
    dispatch(deleteProductGroupItemThunk({ id, group: getGroup() }));
  };
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <Stack spacing={2}>
              <TextField
                label="Name"
                variant="outlined"
                name="name"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.name)}
                helperText={formik.errors.name}
                autoComplete="new-password"
                type="text"
                required
              />
            </Stack>
          </Grid>
        </Grid>
        {status?.error === "create" && (
          <Alert sx={{ mt: 3 }} severity="error">
            Error occurred
          </Alert>
        )}
        {status?.success === "create" && (
          <Snackbar
            open={status?.success === "create" || status?.success === "update"}
            autoHideDuration={6000}
            onClose={() => dispatch(clearStatus())}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            sx={{ paddingX: 5 }}
          >
            <Alert severity="success" onClose={() => dispatch(clearStatus())}>
              Success !
            </Alert>
          </Snackbar>
        )}
        <LoadingButton
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
          loading={status?.loading === "create"}
        >
          {group || currentItem ? "Update name" : "Set name"}
        </LoadingButton>
      </form>
      <Box sx={{ marginTop: 2 }}>
        {(group || currentItem) && (
          <Box
            component={Typography}
            variant="h4"
            sx={{ textDecoration: "underline", color: "text.secondary", mb: 1 }}
          >
            Add products to this group
          </Box>
        )}

        {getGroup()?.items?.length > 0 && (
          <Grid container spacing={1.5} paddingY={1}>
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 6}>
              <Stack spacing={2}>
                <Box
                  sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
                  padding={1}
                >
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ minWidth: 100 }}>
                            {isSmallScreen ? "Product" : "Product name"}
                          </TableCell>
                          <TableCell align="center" sx={{ minWidth: 80 }}>
                            {isSmallScreen ? "Count" : "Product count"}
                          </TableCell>

                          <TableCell>&nbsp;</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {getGroup()?.items.map((group, id) => (
                          <TableRow
                            key={id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {group.product_name}
                            </TableCell>
                            <TableCell align="center">{group.qty}</TableCell>

                            <TableCell align="center">
                              <LoadingButton
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  removeGroup(group.id);
                                }}
                                loading={
                                  status?.loading === "delete" &&
                                  status?.id === group.id
                                }
                              >
                                Delete
                              </LoadingButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        )}
        {(group || currentItem) && (
          <Box marginTop={2}>
            <form onSubmit={formikGroup.handleSubmit}>
              <Grid container spacing={1.5} paddingY={1}>
                <Grid
                  item
                  xs={12}
                  md={fullGrid ? 12 : 6}
                  lg={fullGrid ? 12 : 4}
                >
                  <Stack spacing={2}>
                    <AutoCompleteListFormik
                      items={products}
                      name="name"
                      label="Products"
                      formik={formikGroup}
                      formikName="product"
                      required={true}
                    />
                    <TextField
                      label="Qty"
                      variant="outlined"
                      name="qty"
                      fullWidth
                      value={formikGroup.values.qty}
                      onChange={formikGroup.handleChange}
                      error={Boolean(formikGroup.errors.qty)}
                      helperText={formikGroup.errors.qty}
                      autoComplete="new-password"
                      type="number"
                      required
                    />
                  </Stack>
                </Grid>
              </Grid>
              {status?.error === "create" && (
                <Alert sx={{ mt: 3 }} severity="error">
                  Error occurred
                </Alert>
              )}

              <LoadingButton
                variant="contained"
                type="submit"
                sx={{ paddingX: 10, marginTop: 1 }}
                loading={status?.loading === "create"}
              >
                Add item
              </LoadingButton>
            </form>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ProductGroupingCreate;
